import React from 'react';

import styled from 'styled-components';

import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';
import { useStoreContext } from 'state/store';

import Disclaimer, { DisclaimerPlain } from './disclaimer';

const BoxDisclaimers = styled.div`
  padding: 0 1rem;
  margin: 1rem 0 1rem 0;
`;

const DisclaimerPlainLeft = styled(DisclaimerPlain)`
  text-align: left;
`;

interface ILegalDisclaimers {
  hideNutritionLegalDisclaimer?: boolean;
}

const LegalDisclaimers = ({ hideNutritionLegalDisclaimer = false }: ILegalDisclaimers) => {
  const { noStoreSelected } = useStoreContext();
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { superUpsell, calorie, itemAvailability } = featureDisclaimers || {};

  return (
    <BoxDisclaimers>
      {noStoreSelected && <DisclaimerPlainLeft>{itemAvailability?.locale}</DisclaimerPlainLeft>}
      {!hideNutritionLegalDisclaimer && (
        <div data-testid="wizard-nutrition-disclaimer">
          <Disclaimer content={superUpsell?.localeRaw} />
          <Disclaimer content={calorie?.localeRaw} />
        </div>
      )}
    </BoxDisclaimers>
  );
};

export default LegalDisclaimers;
